// src/react/HighlightPlugin.tsx
import { Key, toPlatePlugin } from "@udecode/plate/react";

// src/lib/BaseHighlightPlugin.ts
import { createSlatePlugin } from "@udecode/plate";
var BaseHighlightPlugin = createSlatePlugin({
  key: "highlight",
  node: { isLeaf: true },
  parsers: {
    html: {
      deserializer: {
        rules: [
          {
            validNodeName: ["MARK"]
          }
        ]
      }
    }
  }
});

// src/react/HighlightPlugin.tsx
var HighlightPlugin = toPlatePlugin(
  BaseHighlightPlugin,
  ({ editor, type }) => ({
    shortcuts: {
      toggleHighlight: {
        keys: [[Key.Mod, Key.Shift, "h"]],
        preventDefault: true,
        handler: () => {
          editor.tf.toggleMark(type);
        }
      }
    }
  })
);
export {
  HighlightPlugin
};
//# sourceMappingURL=index.mjs.map